import React from "react";
import {
    RichTextBasic,
    type RichTextBasicProps,
} from "@/components/RichTextBasic";
import {
    RichTextFull,
    type RichTextFullProps,
} from "@/components/RichTextFull";

export interface RichTextProps extends RichTextBasicProps {
    type?: "full" | "basic";
    rounded?: boolean;
    hideFullscreen?: boolean;
    onFullscreenClick?: () => void;
}

export const RichText: React.FC<RichTextProps> = ({
    type = "full",
    ...props
}: RichTextProps) => {
    if (type === "basic") {
        return <RichTextBasic {...props} />;
    }

    return <RichTextFull {...props} />;
};

export default RichText;
